import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { getCopy } from '../../data/siteCopy';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { language } = useLanguage();
  const copy = getCopy(language);

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">Augusta Silva</Link>
            <p className="footer-tagline">{copy.footer.tagline}</p>
          </div>
          
          <nav className="footer-nav">
            <Link to="/" className="footer-link">{copy.nav.work}</Link>
            <Link to="/about" className="footer-link">{copy.nav.about}</Link>
            <Link to="/contact" className="footer-link">{copy.nav.contact}</Link>
          </nav>
          
          <div className="footer-contact">
            <a href="mailto:augusta.silva.design@gmail.com" className="footer-link">
              augusta.silva.design@gmail.com
            </a>
            <div className="footer-social">
              <a 
                href="https://instagram.com/gusmagarts" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                </svg>
              </a>
              <a 
                href="https://www.linkedin.com/in/augusta-silva-design" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                  <rect x="2" y="9" width="4" height="12"></rect>
                  <circle cx="4" cy="4" r="2"></circle>
                </svg>
              </a>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} Augusta Silva. {copy.footer.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
